<template>
	<!-- #7 부록 슬라이드 1장 = 1페이지. 부모가 :id 와 name="capture" 를 루트에 전달(attr fallthrough). -->
	<div class="print-section slide-page">
		<div v-if="slide.type === 'photo'" class="slide-inner">
			<div class="slide-img-box">
				<img v-if="imgUrl" :src="imgUrl" alt="" />
			</div>
			<div v-if="slide.caption" class="slide-caption">{{ slide.caption }}</div>
		</div>
		<!-- blank: 순수 빈 페이지(내용 없음, 페이지 워터마크만) -->
	</div>
</template>

<script>
import { slideImagePath } from '@/utils/printSlides.mjs';

export default {
	name: 'SlidePage',
	props: {
		slide: { type: Object, required: true },
	},
	computed: {
		imgUrl() {
			if (this.slide.type !== 'photo' || !this.slide.imgId) return '';
			return process.env.VUE_APP_HOST_BACK + slideImagePath(this.slide.imgId);
		},
	},
};
</script>

<style scoped>
/* .print-section(1170×min820, padding:20) 안에서 이미지를 비율 유지로 중앙 배치 + 하단 캡션. */
.slide-page {
	display: flex;
	align-items: center;
	justify-content: center;
}
.slide-inner {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
}
.slide-img-box {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}
/* 페이지 1170×820 − padding − 캡션 여유. 비율 유지(width/height auto + max 캡). */
.slide-img-box img {
	max-width: 1090px;
	max-height: 700px;
	width: auto;
	height: auto;
	object-fit: contain;
}
.slide-caption {
	margin-top: 22px;
	font-size: 17px;
	color: #222;
	text-align: center;
	word-break: keep-all;
	line-height: 1.4;
	max-width: 1000px;
}
</style>
